/*
 * @Author: your name
 * @Date: 2021-09-22 23:19:16
 * @LastEditTime: 2024-02-26 18:13:56
 * @LastEditors: wuqinfa
 * @Description: In User Settings Edit
 * @FilePath: /mxc-crm-3.0/src/models/dictionary.ts
 */
import {
  dictionary,
  allSchoolList,
  listAllCity,
} from '../services/dictionary';

import * as cache from '@/utils/cache';

export default {
  namespace: 'dictionary',

  state: {
    /*
      使用 key - value 的数据格式保存字典，比如：
      {
        'INTENTION': {
          "dictName": "意向度",
          "dictCode": "INTENTION",
          "dictItems": [{
            "itemName": "低意向",
            "itemValue": "0"
          }, {
            "itemName": "中意向",
            "itemValue": "1"
          }, {
            "itemName": "高意向",
            "itemValue": "2"
          }]
        },
      }
    */
    dictionary: cache.get('dictionary') || {},
    allSchoolList: [],
    listAllCity: [],
  },

  effects: {
    * dictionary({ payload }: any, { call, put }: any): any {
      const res = yield call(dictionary, payload);

      yield put({
        type: '_dictionary',
        payload: res
      });

      return res;
    },

    * allSchoolList({ payload }: any, { call, put }: any): any {
      const res = yield call(allSchoolList, payload);

      yield put({
        type: '_setState',
        payload: {
          allSchoolList: res.data || [],
        }
      });

      return res;
    },

    *listAllCity({ payload }: any, { call, put }: any): any {
      const res = yield call(listAllCity, payload);

      yield put({
        type: '_listAllCity',
        payload: res,
      });

      return res;
    },
  },

  reducers: {
    _setState(state: any, { payload }: any) {
      return {
        ...state,
        ...payload,
      };
    },

    _dictionary(state: any, { payload }: any) {
      const {
        data = [],
      } = payload;
      const temp = {};

      data.forEach(item => {
        const {
          dictCode,
          dictItems,
        } = item;

        if (dictCode && dictItems && dictItems.length) {
          temp[dictCode] = item;
        }
      });

      cache.set('dictionary', temp);

      return {
        ...state,
        dictionary: temp,
      };
    },

    _listAllCity(state: any, { payload }: any) {
      const { data = [] } = payload || {};

      return {
        ...state,
        listAllCity:
          data?.map?.((item: any) => {
            const { code, name } = item;
            const temp = name.includes('，') ? name : `${name}，${name}`;

            return {
              label: temp,
              value: code,
            };
          }) || [],
      };
    },
  },
};
